import {
  __export
} from "./chunk-7P6ASYW6.mjs";

// src/check/index.ts
var check_exports = {};
__export(check_exports, {
  badging: () => badging,
  barcode: () => barcode,
  clipboard: () => clipboard,
  compression: () => compression,
  connectivity: () => connectivity,
  contacts: () => contacts,
  contentIndexing: () => contentIndexing,
  files: () => files,
  fonts: () => fonts,
  fullscreen: () => fullscreen,
  idleDetection: () => idleDetection,
  install: () => install,
  lazyLoad: () => lazyLoad,
  notification: () => notification,
  payment: () => payment,
  screen: () => screen,
  visibility: () => visibility,
  wakeLock: () => wakeLock,
  webOtp: () => webOtp,
  webShare: () => webShare
});
var badging = () => "badging" in navigator;
var barcode = () => "BarcodeDetector" in window;
var clipboard = () => "clipboard" in navigator;
var compression = () => "CompressionStream" in window;
var connectivity = () => "connection" in navigator;
var contacts = () => "contacts" in navigator;
var contentIndexing = () => "index" in window;
var files = () => "showOpenFilePicker" in window;
var fonts = () => "fonts" in navigator;
var fullscreen = () => "requestFullscreen" in document.documentElement;
var idleDetection = () => "requestIdleCallback" in window;
var install = () => "getInstalledRelatedApps" in navigator;
var lazyLoad = () => "loading" in HTMLImageElement.prototype;
var notification = () => "Notification" in window;
var payment = () => "PaymentRequest" in window;
var screen = () => "getScreenDetails" in window;
var visibility = () => "visibilityState" in document;
var wakeLock = () => "wakeLock" in navigator;
var webOtp = () => "OTPCredential" in window;
var webShare = () => "share" in navigator;

export {
  badging,
  barcode,
  clipboard,
  compression,
  connectivity,
  contacts,
  contentIndexing,
  files,
  fonts,
  fullscreen,
  idleDetection,
  install,
  lazyLoad,
  notification,
  payment,
  screen,
  visibility,
  wakeLock,
  webOtp,
  webShare,
  check_exports
};
